import React, { Component } from 'react';
import { reduxForm, Field, change, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CreatableSelect from 'react-select/lib/Creatable';

import renderField from '../../../../customInputs/renderField';
import renderSelect from '../../../../customInputs/renderSelect';
import renderTypeAhead from '../../../../customInputs/renderTypeAhead';
import renderRemovable from '../../../../customInputs/renderRemovable';
import Utils from '../../../../../lib/utils';
import {CONDITION_MATCHES_VALUE, PQ_ADMIN_ROLE_ID, CF_ADMIN_ROLE_ID} from '../../../../../lib/appConstants';

import * as reqSetsActions from '../../actions';
import * as coverageTypeActions from '../../../coverage-types/actions';

import validation from './requirementValidation';
import { Tooltip, Typography } from '@material-ui/core';
import { HelpOutlineSharp } from '@material-ui/icons';

class RequirementForm extends Component {
  constructor(props){
    super(props);
    this.state = {
      advanceOptionsCollapse : false
    }
  }
  componentDidMount() {
    const { requirement, dispatch } = this.props;

    if (requirement) {
      const attributeObj = {
        value: requirement.AttributeID,
        label: requirement.AttributeName,
      };
      dispatch(change('RequirementSetsRequirementForm', 'attribute', requirement.AttributeID ? attributeObj : null));
      dispatch(change('RequirementSetsRequirementForm', 'conditionTypeId', requirement.ConditionTypeID || ''));
      dispatch(change('RequirementSetsRequirementForm', 'conditionValue', (requirement.ConditionValue !== '') ? requirement.ConditionValue : ''));
      dispatch(change('RequirementSetsRequirementForm', 'deficiencyTypeId', requirement.DeficiencyTypeID || ''));
      dispatch(change('RequirementSetsRequirementForm', 'defaultValue', requirement.DefaultValue || ''));
      dispatch(change('RequirementSetsRequirementForm', 'operator', requirement.Operator || ''));
      dispatch(change('RequirementSetsRequirementForm', 'deficiencyText', requirement.DeficiencyText || ''));

      let AIReferences = [];
      try{
        let parsedReferences = requirement.AIReferences && JSON.parse(requirement.AIReferences);
        if (Array.isArray(parsedReferences)) {
          AIReferences = parsedReferences.map(ref => ({ label: ref, value: ref }));
        }
      } catch(ex){}

      dispatch(change('RequirementSetsRequirementForm', 'aiReferences', AIReferences));      
      const showAdvanceOption = this.shouldShowAdvanceOptions(attributeObj, requirement.ConditionTypeID);
      if (showAdvanceOption) {
        this.setState({ advanceOptionsCollapse: true });
      }
    }
  }

  componentWillUnmount() {
    this.props.coverageTypeActions.resetTypeAheadResults();
    this.props.actions.resetAttributeTypeAheadResults();
  }

  renderFormField = (element, idx) => {
    const {
      name,
      label,
      ph,
      type,
      conditional,
      show,
      options,
      onChange,
      textFieldProps = {}
    } = element;

    const style = {};
    if (conditional && !show) {
      style.display = 'none';
    }

    if (type === 'typeAhead') {
      const { fetching, results, error, handleSearch, onSelect } = element;
      
      return (
        <div key={idx} className="wiz-field admin-form-field-wrapper" style={style}>
          <label htmlFor={name}>{`${label}:`}</label>
          <Field
            resetOnClick
            name={name}
            placeholder={ph}
            fetching={fetching}
            results={results}
            handleSearch={handleSearch}
            fetchError={error}
            component={renderTypeAhead}
            disabled = {this.props.requirement.isDefaultReqSet}
            onSelect={onSelect}
          />
        </div>
      );
    } else if (type === 'removable') {
      const { valueText, disabled, onRemove } = element;
      return (
        <div key={idx} className="wiz-field admin-form-field-wrapper" style={style}>
          <label htmlFor={name}>{`${label}:`}</label>
          <Field
            name={name}
            valueText={valueText}
            component={renderRemovable}
            onRemove={onRemove}
            disabled = { disabled || this.props.requirement.isDefaultReqSet}
            style={this.props.requirement.isDefaultReqSet ? {cursor: 'not-allowed'} : {}}
          />
        </div>
      );
    }
    if(type === 'advanceOption' && show){
      const holderRequirementSets = this.props.holderRequirementSets || {};
      const fields = holderRequirementSets.fields || [];
      const advanceOptionFields = fields.filter(function (field) {
        return field.type === 'advanceOption' && field.show;
      }) || [];
  
      if (!advanceOptionFields[0] || idx !== advanceOptionFields[0].idx) return null;
 
      return (
        <div className='advance-option-container'>
            <button
              type="button"
              onClick={() =>
                this.setState((prevState) => ({
                  advanceOptionsCollapse: !prevState.advanceOptionsCollapse,
                }))
              }
            >
              <span>Advance Options</span>
              {this.state.advanceOptionsCollapse ? (
                <span className='rotate-icon'>&#10148;</span>
              ) : (
                <span>&#10148;</span>
            )}
            </button>
            {this.state.advanceOptionsCollapse && (
              <div className="admin-form-field-wrapper" style={style}>
                {advanceOptionFields.map((advField) => (
                  <div key={advField.name} className="advance-option-field">
                    <div className='advance-option-label-container' style={{display: 'flex'}}>
                      <label htmlFor={advField.name}>{advField.label}</label>
                      {advField.name === 'operator' && (
                        <Tooltip placement="top" title={<Typography style={{ fontSize: 11, lineHeight: '14px', padding: '3px 0' }}>Operator</Typography>}>
                          <HelpOutlineSharp />
                        </Tooltip>
                      )}
                      {advField.name === 'aiReferences' && (
                        <Tooltip placement="top" title={<Typography style={{ fontSize: 11, lineHeight: '14px', padding: '3px 0' }}>References.</Typography>}>
                          <HelpOutlineSharp />
                        </Tooltip>
                      )}
                      {advField.name === 'defaultValue' && (
                        <Tooltip placement="top" title={<Typography style={{ fontSize: 11, lineHeight: '14px', padding: '3px 0' }}>This is the default value that will be applied automatically during the data entry process, whether the data is extracted via Hawk-I or entered manually.</Typography>}>
                          <HelpOutlineSharp/>
                        </Tooltip>
                      )}
                    </div>
                    {
                      advField.name === 'aiReferences' ? (
                        <div className='creatable-multiselct-wrapper'>
                            <Field
                              name="aiReferences"
                                component={({ input }) => (                               
                                  <CreatableSelect
                                    isMulti
                                    isClearable
                                    value={input.value || null }
                                    onChange={(newValue) => {
                                      const updatedValue = newValue && newValue.length > 0 ? newValue : null;
                                      input.onChange(updatedValue);
                                      this.props.dispatch(change('RequirementSetsRequirementForm', 'aiReferences', updatedValue));
                                    }}
                                    onCreateOption={(inputValue) => {
                                      const newOption = {
                                        label: inputValue,
                                        value: inputValue.trim()
                                      };
                                      const currentValue = Array.isArray(input.value) ? input.value : [];
                                      input.onChange([...currentValue, newOption]);
                                    }}
                                    formatCreateLabel={(inputValue) => `Enter to Create "${inputValue}"`}
                                    placeholder="Type here..."
                                    isDisabled={this.props.requirement.isDefaultReqSet}
                                  />
                                )}
                            />
                            </div>
                      ) : (
                        <div className="select-wrapper">
                        <Field
                          name={advField.name}
                          component={renderSelect}
                          options={advField.options}
                          onChange={advField.onChange}
                          disabled={this.props.requirement.isDefaultReqSet}
                          style={this.props.requirement.isDefaultReqSet ? { cursor: "not-allowed" } : {}}
                        />
                      </div>
                      )
                    }
                  </div>
                ))}
              </div>
            )}
        </div>
      )
    }

    if (options) {
      return (
        <div key={idx} className="admin-form-field-wrapper" style={style}>
          <label htmlFor={name}>{`${label}:`}</label>
          <div className="select-wrapper">
            <Field
              name={name}
              component={renderSelect}
              options={options}
              onChange={onChange}
              disabled = {this.props.requirement.isDefaultReqSet}
              style={this.props.requirement.isDefaultReqSet ? {cursor: 'not-allowed'} : {}}
            />
          </div>
        </div>
      );
    }
    return (
      <div key={idx} className="admin-form-field-wrapper" style={style}>
        <label htmlFor={name}>{`${label}:`}</label>
        <Field
          name={name}
          type={type || "text"}
          placeholder={ph}
          valueText={element.valueText}
          component={renderField}
          disabled = {this.props.requirement.isDefaultReqSet}
          style={this.props.requirement.isDefaultReqSet ? {cursor: 'not-allowed'} : {}}
          {...textFieldProps}
        />
      </div>
    );
  }

  onRemoveCoverageType = () => {
    this.props.dispatch(change('RequirementSetsRequirementForm', 'coverageType', null));
    this.props.dispatch(change('RequirementSetsRequirementForm', 'ruleGroupName', ''));
  }

  onSelectCoverageType = (selected) => {
    this.props.dispatch(change('RequirementSetsRequirementForm', 'coverageType', selected));
    this.props.dispatch(change('RequirementSetsRequirementForm', 'ruleGroupName', selected.label));
  }

  shouldShowAdvanceOptions = (attributeCurrentValue, conditionTypeCurrentValue) => {
    if (!(attributeCurrentValue && attributeCurrentValue.label)) return false;

    const label = attributeCurrentValue.label.trim().toLowerCase();
    const specialAttributes = [
      "additional insured verbiage",
      "insured name",
      "certificate holder",
      "waiver of subrogation verbiage",
      "primary & non-contributory verbiage",
      "loss payee",
    ];
    
    return specialAttributes.some(key => label.includes(key)) ||
           (label.includes("producer validation") && Number(conditionTypeCurrentValue) === 1);
  };

  shouldShowDefaultValue = (attributeCurrentValue, conditionTypeCurrentValue) => {
    if (!(attributeCurrentValue && attributeCurrentValue.label)) return false;

    const label = attributeCurrentValue.label.trim().toLowerCase();
    return label.includes("producer validation") && Number(conditionTypeCurrentValue) === 1;
  };

  shouldShowOperatorAndReferences = (attributeCurrentValue) => {
    const { profile } = this.props;
    
    if (!(attributeCurrentValue && attributeCurrentValue.label)) return false;

    if((profile.CFRole && profile.CFRole.Id === CF_ADMIN_ROLE_ID) || (profile.Role && profile.Role.Id === PQ_ADMIN_ROLE_ID)){
      const label = attributeCurrentValue.label.trim().toLowerCase();
      const specialAttributes = [
        "additional insured verbiage",
        "insured name",
        "certificate holder",
        "waiver of subrogation verbiage",
        "primary & non-contributory verbiage",
        "loss payee",
      ];
      return specialAttributes.some(key => label.includes(key));
    }
    return false;
  };
  
  handleAttributeChange = (attributeCurrentValue, conditionTypeCurrentValue) => {
    const { dispatch } = this.props;
    let defaultValue = '';
    let operatorValue = '';
    let aiReferenceValue = null;
    let advanceOptionsCollapse = false;
  
    const showAdvanceOption = this.shouldShowAdvanceOptions(attributeCurrentValue, conditionTypeCurrentValue);
  
    if (showAdvanceOption) {
      if (this.shouldShowDefaultValue(attributeCurrentValue, conditionTypeCurrentValue)) {
        defaultValue = 'CHECKED';
      }
      if (this.shouldShowOperatorAndReferences(attributeCurrentValue)) {
        operatorValue = ''; 
        aiReferenceValue = null;
      }
      advanceOptionsCollapse = true;
    }
  
    dispatch(change('RequirementSetsRequirementForm', 'defaultValue', defaultValue));
    dispatch(change('RequirementSetsRequirementForm', 'operator', operatorValue));
    dispatch(change('RequirementSetsRequirementForm', 'aiReferences', aiReferenceValue));
  
    this.setState({ advanceOptionsCollapse });
  };
  
  onChangeAttribute = (e) => {
    const { attributeCurrentValue } = this.props;
    const conditionTypeCurrentValue = e.target.value;
  
    this.handleAttributeChange(attributeCurrentValue, conditionTypeCurrentValue);
  };
  
  onSelectAttribute = (attributeCurrentValue) => {
    const { conditionTypeCurrentValue } = this.props;
  
    this.handleAttributeChange(attributeCurrentValue, conditionTypeCurrentValue);
  };

  render() {
    const {
      handleSubmit,
      conditionTypeCurrentValue,
      attributeCurrentValue,
      fromSettingsTab,
      coverageTypeValue,
      requirement,
      coverageTypeActions,
      holderId,
    } = this.props;

    const {
      valueStatusOptions,
      deficiencyTypeOptions,
      valueRatingOptions,
      conditionPossibleValues,
      AMBestFinancialSizeOptions,
      operatorOptions
    } = this.props.holderRequirementSets;

    const {
      titleText,
      attributeLabel,
      conditionLabel,
      valueLabel,
      deficiencyTextLabel,
      deficiencyTypeLabel,
      saveButton,
      cancelButton,
    } = this.props.local.strings.holderRequirementSets.details.addRequirementModal;

    const {
      nameLabel,
      coverageLabel,
    } = this.props.local.strings.holderRequirementSets.details.addRequirementGroupModal;

    const {
      typeAheadError,
      typeAheadFetching,
      typeAheadResults,
    } = this.props.coverageTypes;

    const {
      attributeTypeAheadError,
      attributeTypeAheadFetching,
      attributeTypeAheadResults,
    } = this.props.holderRequirementSets;

    const selectedCoverageTypeId = (requirement) 
      ? requirement.CoverageTypeID 
      : (coverageTypeValue) ? coverageTypeValue.value : undefined;

    const coverageOptions = Utils.getOptionsList(null, typeAheadResults, 'Name', 'CoverageTypeID', 'Name');
    const attributeOptions = Utils.getOptionsList(null, attributeTypeAheadResults, 'AttributeName', 'AttributeID', 'AttributeName');
    const shouldShowDefaultValue = this.shouldShowDefaultValue(attributeCurrentValue, conditionTypeCurrentValue);
    const shouldShowOperatorAndReferences = this.shouldShowOperatorAndReferences(attributeCurrentValue);

    const fields = [
      {
        name: 'coverageType', label: coverageLabel, ph:'-- Search Coverage Type --', type: 'typeAhead',
        handleSearch: (term) => coverageTypeActions.fetchTypeAhead({ name: term, holderId }), fetching: typeAheadFetching, results: coverageOptions,
        error: typeAheadError, conditional: true, show: !coverageTypeValue && fromSettingsTab && !requirement, onSelect: this.onSelectCoverageType,
        onRemove: this.onRemoveHolder
      },
      {
        name: 'coverageType', label: coverageLabel, type: 'removable',
        valueText: coverageTypeValue ? coverageTypeValue.label : '', onRemove: this.onRemoveCoverageType,
        conditional: true, show: coverageTypeValue && fromSettingsTab && !requirement,
      },
      { 
        name: 'ruleGroupName', label: nameLabel, ph: '-- Name --', conditional: true,
        show: fromSettingsTab && !requirement
      },
      {
        name: 'attribute', label: attributeLabel, ph:'-- Attribute --', type: 'typeAhead',
        handleSearch:  (term) => this.props.actions.fetchAttributeTypeAhead({ name: term, coverageTypeId: selectedCoverageTypeId }), fetching: attributeTypeAheadFetching, results: attributeOptions,
        error: attributeTypeAheadError, conditional: true, show: !attributeCurrentValue,
        onSelect: this.onSelectAttribute,
      },
      {
        name: 'attribute', label: attributeLabel, type: 'removable',
        valueText: attributeCurrentValue ? attributeCurrentValue.label : '', onRemove: this.onRemoveHolder,
        conditional: true, show: attributeCurrentValue,
      },
      { name: 'conditionTypeId', label: conditionLabel, options: conditionPossibleValues, onChange: this.onChangeAttribute},
      { 
        name: 'conditionValue', label: valueLabel, ph: '-- 00 --', conditional: true, 
        show: (Number(conditionTypeCurrentValue) > 3 && Number(conditionTypeCurrentValue) <= 7)
      },
      { 
        name: 'conditionValue', label: valueLabel, conditional: true,
        show: Number(conditionTypeCurrentValue) === 1, options: valueStatusOptions 
      },
      { 
        name: 'conditionValue', label: valueLabel, conditional: true, 
        show: (Number(conditionTypeCurrentValue) === 2) || (Number(conditionTypeCurrentValue) === 3), 
        options: valueRatingOptions 
      },
      { 
        name: 'conditionValue', label: valueLabel, conditional: true, 
        show: (Number(conditionTypeCurrentValue) === 8) || (Number(conditionTypeCurrentValue) === 9), 
        options: AMBestFinancialSizeOptions 
      },
      { 
        name: 'conditionValue', label: valueLabel, conditional: true, 
        show: (Number(conditionTypeCurrentValue) === 10), type:'textarea'
      },
      { name: 'deficiencyTypeId', label: deficiencyTypeLabel, options: deficiencyTypeOptions },
      { name: 'deficiencyText', label: deficiencyTextLabel, ph: '-- Deficiency Text --', type:'textarea' },
      { name: 'defaultValue'
        , conditional: true
        , label: 'Default Value'
        , show: shouldShowDefaultValue
        , type: 'advanceOption'
        , options: valueStatusOptions
      },
      {
        name: 'operator',
        conditional: true,
        label: 'Operator',
        show: shouldShowOperatorAndReferences,
        type: 'advanceOption',
        options: operatorOptions
      },
      {
        name: 'aiReferences',
        conditional: true,
        label: 'References',
        show: shouldShowOperatorAndReferences,
        type: 'advanceOption'
      }
    ];

    fields.forEach((field, index) => {
      field.idx = index;
    });

    this.props.holderRequirementSets.fields = fields;

    return (
      <div className="add-item-view add-entity-form-small requirement-form-modal">
        <div className="add-item-header">
          <h1>{requirement ? 'Edit': 'Add'} {titleText}</h1>
        </div>

        <section className="white-section">
          <div className="add-item-form-subsection">
            <form
              autoComplete="off"
              className="entity-info-form"
              onSubmit={handleSubmit}
            >
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12">
                    {fields.map(this.renderFormField)}
                  </div>
                </div>
              </div>

              {this.props.holderRequirementSets.rulesGroupsError &&
                <div className="error-item-form">
                  {this.props.holderRequirementSets.rulesGroupsError}
                </div>
              }

              <div className="add-item-bn">
                <button
                  disabled = {this.props.requirement.isDefaultReqSet}
                  className={`bn bn-small bg-green-dark-gradient create-item-bn icon-save ${this.props.requirement.isDefaultReqSet && "v-cursor-not-allowed"}`}
                  type="submit"
                >
                  {saveButton}
                </button>
                <a
                  className="cancel-add-item"
                  onClick={() => this.props.close()} >
                  {cancelButton}
                </a>
              </div>

            </form>
          </div>
        </section>
      </div>
    );
  }
}

RequirementForm = reduxForm({
  form: 'RequirementSetsRequirementForm',
  validate: validation,
})(RequirementForm);

const mapStateToProps = (state) => {
  return {
    currentForm: state.form,
    local: state.localization,
    holderRequirementSets: state.holderRequirementSets,
    coverageTypes: state.coverageTypes,
    coverageTypeValue: formValueSelector('RequirementSetsRequirementForm')(state, 'coverageType'),
    conditionTypeCurrentValue: formValueSelector('RequirementSetsRequirementForm')(state, 'conditionTypeId'),
    attributeCurrentValue: formValueSelector('RequirementSetsRequirementForm')(state, 'attribute'),
    profile: state.login.profile,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(reqSetsActions, dispatch),
    coverageTypeActions: bindActionCreators(coverageTypeActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RequirementForm);
